import { userApi as api, userSilentApi as silentApi } from "../../utils/apiInstances";

const buildQueryString = (params: Record<string, unknown> = {}) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
            return;
        }
        searchParams.set(key, String(value));
    });

    const query = searchParams.toString();
    return query ? `?${query}` : "";
};

export const handleGetOrganizerApplication = async <TData = unknown>() => {
    try {
        const response = await silentApi<TData>("GET", "/user/organizer/application");
        return response;
    } catch (error) {
        console.error("Error fetching organizer application:", error);
        throw error;
    }
};

export const handleSubmitOrganizerApplication = async <TData = unknown>(payload: unknown) => {
    try {
        const response = await api<TData>(
            "POST",
            "/user/organizer/application",
            payload
        );
        return response;
    } catch (error) {
        console.error("Error submitting organizer application:", error);
        throw error;
    }
};

export const handleGetOrganizerBanks = async <TData = unknown>(countryCode?: string) => {
    try {
        const query = countryCode ? `?country_code=${encodeURIComponent(countryCode)}` : "";
        const response = await silentApi<TData>("GET", `/user/organizer/banks${query}`);
        return response;
    } catch (error) {
        console.error("Error fetching organizer payout banks:", error);
        throw error;
    }
};

export const handleVerifyOrganizerBankAccount = async <TData = unknown>(payload: unknown) => {
    try {
        const response = await api<TData>(
            "POST",
            "/user/organizer/verify-bank-account",
            payload
        );
        return response;
    } catch (error) {
        console.error("Error verifying organizer bank account:", error);
        throw error;
    }
};

export const handleFetchOrganizerDashboardSummary = async <TData = unknown>() => {
    try {
        const response = await silentApi<TData>("GET", "/organizer/dashboard/summary");
        return response;
    } catch (error) {
        console.error("Error fetching organizer dashboard summary:", error);
        throw error;
    }
};

export const handleGetPublicOrganizerProfile = async <TData = unknown>(organizerId: string | number) => {
    try {
        const response = await silentApi<TData>(
            "GET",
            `/user/public-organizers/${organizerId}`
        );
        return response;
    } catch (error) {
        console.error("Error fetching public organizer profile:", error);
        throw error;
    }
};

export const handleGetOrganizerFollowStatus = async <TData = unknown>(organizerId: string | number) => {
    try {
        const response = await silentApi<TData>(
            "GET",
            `/user/organizers/${organizerId}/follow-status`
        );
        return response;
    } catch (error) {
        console.error("Error fetching organizer follow status:", error);
        throw error;
    }
};

export const handleFollowOrganizer = async <TData = unknown>(organizerId: string | number) => {
    try {
        const response = await api<TData>(
            "POST",
            `/user/organizers/${organizerId}/follow`
        );
        return response;
    } catch (error) {
        console.error("Error following organizer:", error);
        throw error;
    }
};

export const handleUnfollowOrganizer = async <TData = unknown>(organizerId: string | number) => {
    try {
        const response = await api<TData>(
            "DELETE",
            `/user/organizers/${organizerId}/follow`
        );
        return response;
    } catch (error) {
        console.error("Error unfollowing organizer:", error);
        throw error;
    }
};

export const handleGetOrganizerReviews = async <TData = unknown>(params: Record<string, unknown> = {}) => {
    try {
        const response = await silentApi<TData>(
            "GET",
            `/organizer/ratings${buildQueryString(params)}`
        );
        return response;
    } catch (error) {
        console.error("Error fetching organizer reviews:", error);
        throw error;
    }
};
